/**
 * How long an invitation lasts.
 *
 * Here, in the shared package, because two runtimes set it: the client writes
 * `expiresAt` when an owner creates an invitation, and the Cloud Function that
 * re-sends one moves it forward. Two copies of a fortnight is how an invitation
 * ends up expiring a week before the email that carried it says it will.
 *
 * A fortnight, because the person being invited is a vet or a family member who
 * may not open their email for a week, and because an invitation that never
 * expires is a permanent key to a kennel's records sitting in an inbox.
 */
export const INVITE_TTL_MS = 14 * 24 * 60 * 60 * 1000;

/** The same, in whole days, for a sentence in an email. */
export const INVITE_TTL_DAYS = INVITE_TTL_MS / 86_400_000;
